import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Col,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Grid,
  Heading5,
  Image,
  JustifyContent,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import type { SearchCategoryGridContentBlock } from '@library/api-menu-experience'

import type { MenuSearchContentProps } from './types'

export type SearchCategoryGridProps = {
  contentBlock: SearchCategoryGridContentBlock
  onCategoryClick: MenuSearchContentProps['onCategoryClick']
}

export const SearchCategoryGrid = ({
  contentBlock: { title, items },
  onCategoryClick,
}: SearchCategoryGridProps) => (
  <Box>
    <Heading5>{title}</Heading5>
    <Space size={4} />
    <Grid gap={[3, null, 4]}>
      {items.map((category) => {
        const image = category.image.crops[0]

        return (
          <Col key={category.id} size={[6, null, 4]}>
            <Box
              aria-label={`Visit ${category.title}`}
              alignItems={AlignItems.Center}
              display={Display.Flex}
              flexDirection={FlexDirection.Column}
              justifyContent={JustifyContent.Center}
              onClick={() => onCategoryClick(category)}
              onKeyDown={(event: React.KeyboardEvent) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                  event.preventDefault()
                  onCategoryClick(category)
                }
              }}
              paddingV={2}
              position={DisplayPosition.Relative}
              role="button"
              style={{ cursor: 'pointer' }}
              tabIndex={0}
            >
              <Box bg={Color.NeutralGrey_50} height="65px" width="100%" />
              {image && (
                <Box position={DisplayPosition.Absolute} top="0">
                  <Image
                    alt={category.image.altText ?? category.title}
                    height="auto"
                    src={image.url}
                    width="90px"
                  />
                </Box>
              )}
              <Box paddingBottom={0} paddingV={2}>
                <Body2
                  color={Color.ColdGrey_800}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                >
                  {category.title}
                  <Text color={Color.ColdGrey_500} display={Display.Inline} size={2}>
                    &nbsp;&nbsp;{category.recipeCount}
                  </Text>
                </Body2>
              </Box>
            </Box>
          </Col>
        )
      })}
    </Grid>
  </Box>
)
